let memoizedTheme;
let previousSubtheme;
let previousDirection;

export function getThemeObject(direction, subtheme) {
  if (!memoizedTheme || previousDirection !== direction || previousSubtheme !== subtheme) {
    previousSubtheme = subtheme;
    previousDirection = direction;
    memoizedTheme = { locale: { dir: direction }, ...subtheme };
  }
  return memoizedTheme;
}
